export interface PaymentFactRequestInput {
  paymentFactId?: string | null
}

export interface PaymentFactRequest {
  paymentFactId: string
}

export function requirePaymentFactRequest(body?: PaymentFactRequestInput | null): PaymentFactRequest {
  const paymentFactId = body?.paymentFactId?.trim()
  if (!paymentFactId) {
    throw new Error('支付或结算标识不能为空')
  }
  return { paymentFactId }
}
